import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import IVariation, { IVariationInput } from "@/interfaces/variation.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class VariationService {
  private baseUrl = "api/v1/ProductVariation";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IVariation>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const variations = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return variations;
  }

  async filter(
    filter: IFilter<IVariation>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IVariation>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: IVariationInput): Promise<void> {
    await httpRequest.post(this.baseUrl, formData);
  }

  async getById(variationId: number): Promise<IVariation> {
    const variation = await httpRequest.get(`${this.baseUrl}/${variationId}`);
    return variation;
  }

  async update(formData: IVariationInput, variationId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${variationId}`, formData);
  }

  async delete(variationId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${variationId}`);
  }
}

const variationService = new VariationService();
export default variationService;
